import {fetchBaseQuery, retry} from "@reduxjs/toolkit/query/react"
import {store} from "../Store";

export const apiQueryV2 = retry(
    fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_BASE_URL + "/v2",
        prepareHeaders: (headers, {getState}) => {
            const {auth: {token}} = (getState as typeof store.getState)();

            headers.set("Authorization", `Bearer ${token}`)
            headers.set("Accept", "application/json")

            return headers
        },


    })
    , {maxRetries: 3})

export const apiQueryV1 = retry(fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL + "/v1",
    prepareHeaders: (headers, {getState}) => {
        const {auth: {token}} = (getState as typeof store.getState)();
        headers.set("Authorization", `Bearer ${token}`)
        headers.set("Accept", "application/json")
        return headers
    },
}), {maxRetries: 3})

export const apiQueryTeletechV1 = retry(fetchBaseQuery({
    baseUrl: process.env.REACT_APP_TELETECH_API_BASE_URL + "/api/v1",
    prepareHeaders: (headers, {getState}) => {
        const {auth: {teletechToken}} = (getState as typeof store.getState)();
        headers.set("Authorization", `Bearer ${teletechToken}`)
        headers.set("Accept-Language", "ru")
        headers.set("Accept", "application/json")
        headers.set("X-Time-Zone", "GMT+5")
        return headers
    },
}), {maxRetries: 3})

